<!--
动画流程: title, slogan, desc, list 在进入窗口范围后分别以 1s 的速度从下向上淡入
适配: laptop 下内容整体左移 100
-->
<template>
  <div id="js-culture">
    <div id="js-culture-wrap" :class="$style.culture">
      <h2 id="js-culture-title" :class="$style.title">
        <span class="app-fadeInUp">企业文化</span>
      </h2>
      <div id="js-culture-slogan" :class="$style.slogan">
        <div class="app-fadeInUp" v-html="cultureData.slogan" />
      </div>
      <div id="js-culture-desc" :class="$style.desc">
        <div class="app-fadeInUp" v-html="cultureData.detail" />
      </div>
      <div id="js-culture-list" :class="$style.list">
        <div :class="[$style.list_wrap, 'app-fadeInUp']">
          <div
            v-for="(el, index) in keysList"
            :key="index"
            :class="[
              $style.list_item,
              $style[`list_item_${el.id}`],
              el.info && $style.list_item_bar,
            ]"
          >
            <h3>{{ el.title }}</h3>
            <p v-if="el.info">{{ el.info }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import aboutMixins from '@/assets/js/aboutMixins'

export default {
  mixins: [aboutMixins],
  data() {
    return {
      name: 'culture',
      animateScenesData: ['title', 'slogan', 'desc', 'list'],
    }
  },
  computed: {
    ...mapGetters(['cultureData']),
    keysList() {
      if (this.cultureData.keys) {
        const entries = Object.entries(JSON.parse(this.cultureData.keys))
        if (entries.length === 4) {
          return entries.map((el) => ({ id: el[0], title: el[1] }))
        }
      }
      return []
    },
  },
}
</script>

<style lang="less" module>
@wrap-height: 10.37rem;
@wrap-padding-left: 9.3rem;
@wrap-padding-right: 1.65rem;

.list-item-size(@r: 1) {
  min-height: 0.9rem * @r;
  margin-top: 0.5rem * @r;
  padding-left: 1.4rem * @r;

  &::before {
    .size(1.14rem * @r, 0.9rem * @r);
  }
}

.culture {
  height: @wrap-height;
  padding-top: @padding-base;
  padding-left: @wrap-padding-left;
  padding-right: @wrap-padding-right;
  background: url('./images/culture-bg.jpg') no-repeat;
  background-size: 19.2rem 100%;
  color: #fff;
  box-sizing: border-box;
}

.title {
  margin-bottom: @padding-title-bot;

  span {
    .subtitle-size(1.36rem, 0.58rem);
    .text-hide();
    display: inline-block;
    vertical-align: top;
    background: url('./images/culture-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.slogan {
  font-size: 0.24rem;
  line-height: 1.5;
  white-space: nowrap;
}

.desc {
  margin-top: 1em;
  font-size: 0.16rem;
  line-height: 2;
}

.list {
  &_wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &_item {
    .list-item-size();
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 45%;
    box-sizing: border-box;

    h3 {
      font-size: 0.18rem;
      font-weight: 200;
    }

    p {
      margin-top: 0.5em;
      color: #828282;
      line-height: 1.5;
    }

    &::before {
      content: '';
      position: absolute;
      top: -0.1rem;
      left: 0;
      background: url('./images/culture-icon.png') no-repeat;
      background-size: 200% 200%;
    }

    &_1::before {
      background-position: 0 0;
    }

    &_2::before {
      background-position: 100% 0;
    }

    &_3::before {
      background-position: 0 100%;
    }

    &_4::before {
      background-position: 100% 100%;
    }
  }
}

@media screen and (max-width: @laptop-width) {
  .culture {
    padding-left: @wrap-padding-left - 1;
  }

  .desc {
    font-size: 0.18rem;
  }

  .list {
    &_item {
      h3 {
        font-size: 14px;
      }

      p {
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .culture {
    height: auto;
    min-height: @wrap-height;
    padding-left: @wrap-padding-left - 2;
    padding-bottom: @padding-base;
    background-position: center 0;
    background-size: auto 100%;
  }

  .slogan {
    font-size: 0.26rem;
  }

  .desc {
    font-size: 0.24rem;
  }
}

@media screen and (max-width: @mini-width) {
  .culture {
    height: auto;
    padding-left: @wrap-padding-right;
    padding-bottom: @padding-base;
    background-position: right 0;
    background-size: 200% 100%;
  }

  .slogan,
  .desc {
    font-size: 14px;
  }

  .list {
    &_item {
      .list-item-size(2);

      &_bar {
        width: 100%;
      }
    }
  }
}
</style>
